import { isGemXDevMode } from '~/server/auth/shopify/helpers';
import isBrowser from '~/utils/isBrowser';
import { getConfig } from './environment';

export interface IShopifyConfig {
  shopifyDomain: string;
}
export const getShopifyConfig = (): IShopifyConfig | undefined => {
  if (!isBrowser()) return;

  if (isGemXDevMode()) {
    return {
      shopifyDomain: getConfig('APP')?.SHOPIFY_APP_SHOP || '',
    };
  }

  return (window as any).__SHOPIFY_CONFIG__;
};
